import { render } from "./CheckExtras.vue?vue&type=template&id=0ac44ad4&scoped=true"
import script from "./CheckExtras.vue?vue&type=script&lang=js"
export * from "./CheckExtras.vue?vue&type=script&lang=js"

import "./CheckExtras.vue?vue&type=style&index=0&id=0ac44ad4&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac44ad4"]])

export default __exports__